module.exports = __webpack_public_path__ + "static/img/Profile-pic.eab6a5a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/Profile-pic.svg
// module id = ltby
// module chunks = 1